import service from '../../http/axios';

// 获取顶部导航
export const getMenu = service({
  url: '/yinghe-api/imageDataScience/getMenu',
});
